export const NEWB_BASE_URL =
  "https://planets-info-by-newbapi.p.rapidapi.com/api/v1/planets/";
export const NINJAS_BASE_URL =
  "https://planets-by-api-ninjas.p.rapidapi.com/v1/planets";
export const NEWB_API_KEY =
  "8147fb38f4mshd345b676bda427fp1d7ffejsn7f75d821b03e";
export const NEWB_API_HOST = "planets-info-by-newbapi.p.rapidapi.com";
export const NINJAS_API_KEY =
  "8147fb38f4mshd345b676bda427fp1d7ffejsn7f75d821b03e";
export const NINJAS_API_HOST = "planets-by-api-ninjas.p.rapidapi.com";

//added basic static URL for the api calls and the api key
